export default __webpack_public_path__ + "static/media/icon-reader-invert.c6627043.svg";